import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { PushNotificationsModule } from 'ng-push-ivy';
import { AsistenciaTramiteComponent } from './asistencia-tramite.component';

import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { InformModalComponent } from '../inform-modal/inform-modal.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AsistenteVentanaModule } from '../asistente-ventana/asistente-ventana.module';
import { BasecomponentsModule } from '../../basecomponents/basecomponents.module';

@NgModule({
   declarations: [
      AsistenciaTramiteComponent,
      
   ],
   imports: [
      FormsModule,
      BasecomponentsModule
   ],
   exports: [
      AsistenciaTramiteComponent
   ],
   providers: [
   ],
   bootstrap: [
      AsistenciaTramiteComponent
   ],
   entryComponents: [
      ConfirmModalComponent,
      InformModalComponent
   ],
   schemas: [
      CUSTOM_ELEMENTS_SCHEMA
   ]
})
export class AsistenciaTramiteModule { }

